var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentStatusReverted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2V5H3.5",
    stroke: "#49C4CB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.755 7.50022C2.0792 8.42041 2.69367 9.21031 3.50583 9.7509C4.31799 10.2915 5.28384 10.5535 6.25786 10.4975C7.23187 10.4414 8.16129 10.0703 8.90606 9.4401C9.65084 8.80989 10.1706 7.95471 10.3871 7.0034C10.6036 6.05209 10.505 5.0562 10.1063 4.16577C9.70758 3.27534 9.03026 2.53862 8.17642 2.0666C7.32257 1.59459 6.33845 1.41285 5.37234 1.54878C4.40623 1.6847 3.51046 2.13093 2.82 2.82022L0.5 5.00022",
    stroke: "#49C4CB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusReverted);
export default __webpack_public_path__ + "static/media/payment_status_reverted.08d53522.svg";
export { ForwardRef as ReactComponent };